import { render, staticRenderFns } from "./mallRenovation.vue?vue&type=template&id=403d190a&scoped=true"
import script from "./mallRenovation.vue?vue&type=script&lang=js"
export * from "./mallRenovation.vue?vue&type=script&lang=js"
import style0 from "./mallRenovation.vue?vue&type=style&index=0&id=403d190a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403d190a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('403d190a')) {
      api.createRecord('403d190a', component.options)
    } else {
      api.reload('403d190a', component.options)
    }
    module.hot.accept("./mallRenovation.vue?vue&type=template&id=403d190a&scoped=true", function () {
      api.rerender('403d190a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mallManagement/mallRenovation/mallRenovation.vue"
export default component.exports